import React from "react";
import { useHistory } from "react-router-dom";

// Components
import TransactionDetailComponent from "../../components/Venues/VenueDetail/TransactionDetail";

const BookingDetailLayout: React.FC<any> = (props: any) => {
  let history = useHistory();
  
  return (
    <div className="row justify-content-center p-3">
      <div className="col col-lg-6 col-md-12 col-sm-12 col-12 p-0">
        <button className="btn blue1" onClick={history.goBack}>
          {" "}
          <svg
            className="bi bi-arrow-left"
            width="1em"
            height="1em"
            viewBox="0 0 16 16"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              d="M5.854 4.646a.5.5 0 0 1 0 .708L3.207 8l2.647 2.646a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 0 1 .708 0z"
            />
            <path
              fillRule="evenodd"
              d="M2.5 8a.5.5 0 0 1 .5-.5h10.5a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"
            />
          </svg>{" "}
          Tornar
        </button>

        {props.acceptedTransaction &&
          props.acceptedTransaction.organizationName?.length 
          ? (<TransactionDetailComponent {...props} />) 
          : null}
      </div>
    </div>
  );
};

export default BookingDetailLayout;
